import React from 'react';
import { motion } from 'framer-motion';

const font = "'Inria Serif', serif";

export const HostLimitedAccessCard = ({
  onReferVenue,
  onInviteHosts,
  testIdPrefix = 'host-limited-access',
}) => (
  <div className="premium-card" data-testid={`${testIdPrefix}-card`} style={{ width: '100%', borderRadius: 28, padding: '18px 16px', display: 'grid', gap: 12 }}>
    <div style={{ display: 'grid', gap: 8 }}>
      <p style={{ fontFamily: font, fontSize: 22, fontWeight: 700, color: 'var(--text)', margin: 0, lineHeight: 1.08 }}>Limited host access</p>
      <p data-testid={`${testIdPrefix}-copy`} style={{ fontFamily: font, fontSize: 15, color: 'var(--text-2)', margin: 0, lineHeight: 1.35 }}>
        Allure isn’t in your area yet—but you can help bring it there. Invite hosts, and refer great venues to speed up the launch.
      </p>
    </div>
    <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
      <motion.button
        type="button"
        onClick={onReferVenue}
        data-testid={`${testIdPrefix}-refer-venue-button`}
        className="premium-pill-button"
        style={{ flex: 1, minWidth: 140, padding: '12px 0', fontFamily: font, fontSize: 16, cursor: 'pointer' }}
        whileHover={{ y: -1.5 }}
        whileTap={{ scale: 0.99 }}
      >
        Refer a venue
      </motion.button>
      <motion.button
        type="button"
        onClick={onInviteHosts}
        data-testid={`${testIdPrefix}-invite-hosts-button`}
        className="premium-pill-button"
        style={{ flex: 1, minWidth: 140, padding: '12px 0', fontFamily: font, fontSize: 16, cursor: 'pointer' }}
        whileHover={{ y: -1.5 }}
        whileTap={{ scale: 0.99 }}
      >
        Invite Hosts
      </motion.button>
    </div>
  </div>
);

export default HostLimitedAccessCard;